<template>
  <div>
    <a-row>
      <a-col v-for="(item, index) in sourceData" :key="index" :span="4" style="margin-right: 10px; margin-bottom: 5px">
        <div class="custom-border">
          <a-row v-if="item.task_type == 3" style="margin-top: 0px">
            <a-avatar shape="square" :size="48" :src="item.image" />
            {{ item.task_name }}
          </a-row>
          <div style="margin-left: 5px">
            <span>
              <a-tag v-if="item.result == 1" color="green">{{ '成功' }}</a-tag>
              <a-tag v-if="item.result == null" color="gold">{{ '执行中' }}</a-tag>
              <a-tag v-if="item.result == 2 || item.result == 3" color="red">{{ '失败' }}</a-tag>
            </span>
            <span style="float: right">
              <a-button v-tc="{ name: '查看自动化报告' }" shape="circle" icon="eye" @click="viewAutomation(item.task_url)" />
              <a-button v-if="false" shape="circle" icon="redo" />
            </span>
          </div>
        </div>
      </a-col>
      <a-col :span="4">
        <div v-tc="{ name: '添加测试套件' }" class="custom-border-add" @click="onAddService"><a-icon type="plus" />添加测试套件</div>
      </a-col>
    </a-row>
    <workflow-test-suit-modal :is-show="addVisible" :workflow-id="workflowId" :current-step-id="currentStepId" :tag="tag" @close="close" />
  </div>
</template>

<script>
import { serviceTypes } from '@/utils/dictionary';
import WorkflowTestSuitModal from '@/pages/project/workflow/components/WorkflowTestSuitModal';

export default {
  components: { WorkflowTestSuitModal },
  model: {
    event: 'change',
    prop: 'sourceData'
  },
  props: {
    projectId: {
      type: Number,
      default: 1
    },
    currentStepId: {
      type: Number,
      default: null
    },
    tag: {
      type: String,
      default: 'qa_verify'
    },
    releaseId: {
      type: Number,
      default: null
    },
    workflowId: {
      type: Number,
      default: null
    },
    sourceData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      serviceTypes,
      services: [],
      selectedServices: [],
      filterForm: {
        service_id: null
      },
      servicesData: {},
      serviceInfo: {},
      modifyService: {},
      modifyIndex: null,
      addVisible: false
    };
  },
  watch: {
    sourceData() {
      this.services = this.sourceData;
      this.selectedServices = this.sourceData.map(item => {
        return item.service_id;
      });
    }
  },
  methods: {
    /**
     * 添加服务
     */
    onAdd() {
      this.$emit('change', this.services);
    },
    /**
     * 点击添加服务
     */
    onAddService() {
      this.modifyService = {};
      this.modifyIndex = null;
      this.addVisible = true;
    },
    viewAutomation(url) {
      window.open(url);
    },

    /**
     * 点击删除服务
     * @param {*} index
     */
    onDelete(index) {
      this.services.splice(index, 1);
      this.selectedServices.splice(index, 1);
    },

    /**
     * 点击修改服务
     * @param {*} record
     * @param {*} index
     */
    onModify(record, index) {
      this.addVisible = true;
      this.modifyService = { ...record };
      this.modifyIndex = index;
    },

    /**
     * 关闭模态框
     */
    close() {
      this.addVisible = false;
    },

    /**
     * 提交添加服务
     * @param {*} service
     * @param {*} index
     */
    submitAddService(service, index = null) {
      this.addVisible = false;
      if (index !== null) {
        this.services[index] = service;
        this.selectedServices[index] = service.service_id;
        this.$emit('change', this.services);
        this.$message.success('服务修改成功');
      } else {
        this.services.push(service);
        this.selectedServices.push(service.service_id);
        this.$emit('change', this.services);
        this.$message.success('服务添加成功');
      }
      this.modifyService = {};
      this.modifyIndex = null;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ant-card {
  margin-bottom: 8px;
}
/deep/.ant-card-body {
  padding: 0px;
}
/deep/.service-form-card .a-card-body {
  margin: 8px 12px;
  width: 30%;
}
.service-card_lable {
  color: rgba(0, 0, 0, 0.35);
  margin-right: 4px;
}
.service-card_name {
  display: inline-block;
  height: 24px;
  margin-left: 8px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
  vertical-align: top;
}
.service-card_action {
  display: inline-block;
  width: 100%;
  text-align: right;
  align-items: right;
}
.service-card_value {
  display: inline;
  line-height: 28px;
}
.custom-border {
  width: 100%;
  height: 100px;
  border: 1px solid #e0e0e0; /* 使用更浅的灰色作为边框颜色 */
}
.custom-border-add {
  width: 100%;
  height: 100px;
  border: 1px solid #e0e0e0; /* 使用更浅的灰色作为边框颜色 */
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;
}
</style>
